/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * App typeface: Inter (self-hosted variable font, loaded in `index.tsx`) with system fallbacks.
 * Kept in its own module so canvas renderers can use it without importing the theme.
 */
export const APP_FONT_FAMILY =
  "'Inter Variable', Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
